import classNames from 'classnames';
import { useMemo } from 'react';
import { useRegisterShareholderList } from '@/modules/investor-dashboard/queries/shareholders.tsx';
import { Select, SelectOption } from 'ui';

interface SelectHolderProps {
  registerId: string;
  setShareholder?: (value?: number) => void;
  shareholderId?: number;
  setEntityId?: (value?: number) => void;
  entityId?: number;
  isClearable?: boolean;
  label?: string;
  labelParentSelect?: string;
  placeholder?: string;
  className?: string;
  showBorderBottom?: boolean;
}

export const SelectHolder = ({
  registerId,
  setShareholder,
  shareholderId,
  isClearable,
  label = 'Holder',
  labelParentSelect,
  placeholder,
  className,
  showBorderBottom = false,
  setEntityId,
  entityId,
}: SelectHolderProps) => {
  const { data: registerShareholderList, isFetching } = useRegisterShareholderList(
    { register_id: +registerId },
    { disabled: !registerId },
  );

  const registerShareholderListOptions = useMemo<
    SelectOption<{ shareholder_id?: number; id?: number; toString?: () => string }>[]
  >(
    () =>
      registerShareholderList?.shareholders?.map(({ id, entity: { entity_name }, entity_id }) => ({
        label: entity_name,
        value: setShareholder
          ? { shareholder_id: id, toString: () => String(id) }
          : setEntityId
          ? { id: entity_id, toString: () => String(entity_id) }
          : { shareholder_id: id, id: entity_id, toString: () => String(id) },
      })) || [],
    [registerShareholderList?.shareholders, setEntityId, setShareholder],
  );

  const handleChangeHolder = (
    options: { shareholder_id?: number; id?: number; toString?: () => string } | null,
  ) => {
    setShareholder && setShareholder(options?.shareholder_id || undefined);
    setEntityId && setEntityId(options?.id || undefined);
  };

  return (
    <div
      className={classNames(
        'flex items-center gap-2 w-full font-[Inter] text-sm leading-[22px]',
        {
          'border px-2 rounded-lg': !showBorderBottom,
          'min-w-[280px]': !className?.includes('min-w-'),
          'max-w-[380px]': !className?.includes('max-w-'),
        },
        className,
      )}
    >
      {label && (
        <span className="border-r pr-2 w-1/2 h-[40px] text-center flex items-center justify-start text-gray-600">
          {label}
        </span>
      )}
      <span
        className={classNames('w-full', {
          'pl-2': !!label,
        })}
      >
        <Select
          key={registerId}
          disabled={!registerId}
          options={registerShareholderListOptions}
          onChange={handleChangeHolder}
          value={
            shareholderId
              ? { shareholder_id: shareholderId, toString: () => String(shareholderId) }
              : entityId
              ? { id: entityId, toString: () => String(entityId) }
              : null
          }
          label={labelParentSelect}
          showBorderBottom={showBorderBottom}
          isClearable={isClearable}
          placeholder={placeholder}
          isLoading={isFetching}
        />
      </span>
    </div>
  );
};
